const DEFAULT_KEY = "graphiql:collections";
const VERSION = 1;
function createLocalStorageAdapter(storageKey = DEFAULT_KEY) {
  return {
    async load() {
      try {
        const raw = localStorage.getItem(storageKey);
        if (!raw) {
          return [];
        }
        const parsed = JSON.parse(raw);
        if (parsed.version !== VERSION) {
          console.warn(
            `[graphiql/plugin-collections] Storage version mismatch (found ${parsed.version}, expected ${VERSION}). Attempting to load collections as-is.`
          );
          return Array.isArray(parsed.collections) ? parsed.collections : [];
        }
        return parsed.collections ?? [];
      } catch {
        return [];
      }
    },
    async save(collections) {
      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({ version: VERSION, collections })
        );
      } catch {
      }
    }
  };
}
const localStorageAdapter = createLocalStorageAdapter();
export {
  createLocalStorageAdapter,
  localStorageAdapter
};
//# sourceMappingURL=local-storage.js.map
